import { z } from 'zod';

export const TaskClosingCodeSchema = z.object({
  id: z.number().or(z.string()),
  taskClosingCode: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите полное название' })
    .max(150, { message: 'До 150 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    }),
  shortName: z
    .string()
    .nonempty({ message: 'Пожалуйста, укажите сокращенное название' })
    .max(10, { message: 'До 10 символов' })
    .refine((value) => value.trim().length > 0, {
      message: 'Поле не может содержать только пробелы'
    })
});
